module.exports = __webpack_public_path__ + "img/logo.711916f9.png";